import React, { useState } from 'react';
import { QUESTIONS, calculateType } from '../data/types';
import './Test.css';

export default function Test({ onComplete }) {
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [exiting, setExiting] = useState(false);

  const q = QUESTIONS[current];
  const progress = ((current) / QUESTIONS.length) * 100;

  const handleChoice = (choice) => {
    if (exiting) return;
    setSelected(choice);
    setExiting(true);
    setTimeout(() => {
      const newAnswers = [...answers, { id: q.id, dim: q.dim, choice }];
      setAnswers(newAnswers);
      setSelected(null);
      setExiting(false);
      if (current + 1 >= QUESTIONS.length) {
        onComplete(calculateType(newAnswers));
      } else {
        setCurrent(c => c + 1);
      }
    }, 380);
  };

  return (
    <div className="test-page">
      <nav className="test-nav">
        <span className="logo-text">
          <span className="logo-ich">ICH</span><span className="logo-type">TYPE</span><span className="logo-de">.DE</span>
        </span>
        <div className="test-counter">
          Frage <span>{current + 1}</span> / {QUESTIONS.length}
        </div>
      </nav>
      <div className="progress-wrap">
        <div className="progress-fill" style={{ width: `${progress}%` }} />
      </div>
      <main className="test-main">
        <div className={`q-card ${exiting ? 'exit' : ''}`}>
          <div className="q-label">Frage {current + 1} von {QUESTIONS.length}</div>
          <h2 className="q-text">{q.text}</h2>
          <div className="choices">
            <button
              className={`choice-btn ${selected === 'a' ? 'selected-a' : ''}`}
              onClick={() => handleChoice('a')}
            >
              <div className="choice-badge">A</div>
              <div className="choice-text">{q.a}</div>
            </button>
            <div className="choice-divider">— oder —</div>
            <button
              className={`choice-btn ${selected === 'b' ? 'selected-b' : ''}`}
              onClick={() => handleChoice('b')}
            >
              <div className="choice-badge">B</div>
              <div className="choice-text">{q.b}</div>
            </button>
          </div>
          <p className="test-hint">Wähle die Antwort, die dich am meisten beschreibt — nicht die die du für "richtig" hältst.</p>
        </div>
      </main>
    </div>
  );
}
